import parser from "ua-parser-js";

// Don't use this on server side it will give you false result
const getDeviceType = () => {
  if (typeof window === "undefined") {
    return {
      isMobileType: false,
      isTabletType: false,
    };
  }

  const type = parser(window.navigator.userAgent).device.type;
  // console.log(type);
  return {
    isMobileType: type === "mobile",
    isTabletType: type === "tablet",
  };
};

export default getDeviceType;
